export default __webpack_public_path__ + "static/media/MH-HAT-FRONT.6ea2ad7b.png";